/**
 * English function words a reader gains nothing from looking up: articles,
 * pronouns, prepositions, conjunctions, auxiliaries and the commonest
 * adverbs. A selection made only of these is not offered a lookup.
 */
export const ENGLISH_STOP_WORDS: ReadonlySet<string> = new Set([
  "a",
  "an",
  "the",
  "and",
  "but",
  "or",
  "nor",
  "so",
  "yet",
  "for",
  "if",
  "then",
  "than",
  "as",
  "at",
  "by",
  "from",
  "in",
  "into",
  "of",
  "off",
  "on",
  "onto",
  "out",
  "over",
  "to",
  "up",
  "with",
  "without",
  "about",
  "after",
  "before",
  "under",
  "until",
  "till",
  "through",
  "i",
  "me",
  "my",
  "mine",
  "myself",
  "we",
  "us",
  "our",
  "ours",
  "ourselves",
  "you",
  "your",
  "yours",
  "yourself",
  "he",
  "him",
  "his",
  "himself",
  "she",
  "her",
  "hers",
  "herself",
  "it",
  "its",
  "itself",
  "they",
  "them",
  "their",
  "theirs",
  "themselves",
  "this",
  "that",
  "these",
  "those",
  "who",
  "whom",
  "whose",
  "which",
  "what",
  "where",
  "when",
  "why",
  "how",
  "am",
  "is",
  "are",
  "was",
  "were",
  "be",
  "been",
  "being",
  "do",
  "does",
  "did",
  "done",
  "have",
  "has",
  "had",
  "having",
  "will",
  "would",
  "shall",
  "should",
  "can",
  "could",
  "may",
  "might",
  "must",
  "not",
  "no",
  "yes",
  "all",
  "any",
  "some",
  "each",
  "every",
  "both",
  "few",
  "more",
  "most",
  "other",
  "such",
  "only",
  "own",
  "same",
  "too",
  "very",
  "just",
  "also",
  "here",
  "there",
  "now",
  "again",
  "once",
  "ever",
  "never",
  "oh",
]);

export const isEnglishStopWord = (word: string): boolean =>
  ENGLISH_STOP_WORDS.has(word);
